import { render, staticRenderFns } from "./DiscountBasicInfo.vue?vue&type=template&id=b7078898&"
import script from "./DiscountBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./DiscountBasicInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports